import * as types from '../constants/idpAdminActions';
import {LAUNCH_ERROR} from "../actions/auth";

const initialState = {
  applianceUrl: null,
  launchError: null,
  loginInProgress: false,
  credentials: null,
};

export default function auth(state = initialState, action = {}) {
  switch (action.type) {
    case types.HANDSHAKE_ACCEPTED:
      return {
        ...state,
        applianceUrl: action.applianceUrl,
        launchError: null,
      };
    case types.HANDSHAKE_REJECTED:
      return {
        ...state,
        launchError: LAUNCH_ERROR.INVALID_CONTEXT,
      };
    case types.AUTH_START:
      return {
        ...state,
        launchError: null,
        loginInProgress: true
      };
    case types.AUTH_SUCCESS:
      return {
        ...state,
        launchError: null,
        credentials: action.response,
        loginInProgress: false,
      };
    case types.AUTH_FAIL:
      return {
        ...state,
        launchError: action.launchError,
        credentials: null,
        loginInProgress: false,
      };
    case types.SESSION_EXPIRED:
      return {
        ...state,
        launchError: LAUNCH_ERROR.SESSION_EXPIRED,
        credentials: null,
      };
    default:
      return state;
  }
}
